import types from './types';

const setPresets = (presets) => ({ type: types.SET_PRESETS, payload: presets });
const setTotalCount = (count) => ({ type: types.SET_TOTAL_COUNT, payload: count });
const setLoading = (loading) => ({ type: types.SET_LOADING, payload: loading });
const setPage = (page) => ({ type: types.SET_PAGE, payload: page });
const setRowsPerPage = (rowsPerPage) => ({ type: types.SET_ROWS_PER_PAGE, payload: rowsPerPage });
const setSearchTerm = (searchTerm) => ({ type: types.SET_SEARCH_TERM, payload: searchTerm });
const updatePresetEnabled = (id, enabled) => ({ type: types.UPDATE_PRESET_ENABLED, payload: { id, enabled } });

export default {
    setPresets,
    setTotalCount,
    setLoading,
    setPage,
    setRowsPerPage,
    setSearchTerm,
    updatePresetEnabled
};
